import React, { useEffect, useState, useRef } from 'react';
import { ClientService } from '../../../../../services/ClientService';
import { AbonnementService } from '../../../../../services/AbonnementService';
import { EditionService } from '../../../../../services/EditionService';
import { Spinner, Card, Tabs, Tooltip, Row, Col, Accordion, Button, Table, Alert, Form, Dropdown, OverlayTrigger, Popover, InputGroup, FormControl } from 'react-bootstrap';
import { useAccordionButton } from 'react-bootstrap/AccordionButton';
import ErrorManager from "../../../../error-manager/ErrorManager";
import ConfirmDialog from '../../../../confirm-dialog/ConfirmDialog';
import Pagination from '../../../../../components/pagination/Pagination';
import { currencyFormat, getFile, granted } from '../../../../../helper/Helper'
import { GlobalContext } from "../../../../../services/GlobalProvider";
import SendMailDialog from "../../../../../components/send-mail-dialog/SendMailDialog";
import { useNavigate } from "react-router";
import PeriodeFilter from "../../../../../components/periode-filter/PeriodeFilter";
import Split from '../../../../../components/split/Split';


const Abonnements = (props) => {

    const { parametres, grants } = React.useContext(GlobalContext);

    const navigate = useNavigate();

    const [getAbonnementsLoading, setGetAbonnementsLoading] = useState(false)
    const [abonnementsData, setAbonnementsData] = useState()
    const [globalError, setGlobalError] = useState()
    const [currentPagination, setCurrentPagination] = useState(1)

    let abonnementsParams = useRef({
        'start': 0,
        'limit': 10,
        'family': null,
        'search': null,
        'filters': null,
        'sort': 'date',
        'order': 'desc',
        'fields': "_id,type,code,date,client_nom,client_id,observation,total_remise,total_taxes,statut,total_prix_revient,total_brut_ht,total_net_ht,total_ttc,historiques"
    });

    useEffect(() => {
        getAbonnements()
    }, []);

    function changePagination(p) {
        setCurrentPagination(p)
        abonnementsParams.current['start'] = (abonnementsParams.current.limit * p) - abonnementsParams.current.limit
    }

    function onChangePagination(p) {
        changePagination(p)
        getAbonnements()
    }

    let getAbonnementsTimeOut;
    function getAbonnements() {
        window.clearTimeout(getAbonnementsTimeOut);
        getAbonnementsTimeOut = window.setTimeout(function () {
            setGetAbonnementsLoading(true)
            setGlobalError()
            ClientService.getAbonnements(props.folderId, props.client._id, abonnementsParams.current).then(res => {
                setGetAbonnementsLoading(false)
                setAbonnementsData(res.data ? res.data.data : null)
            }).catch(error => {
                setGetAbonnementsLoading(false)
                setGlobalError(error)
            });
        }, 600);
    }

    function createNewAbonnement() {
        let newAbonnement = {
            "type": "abonnement",
            "client_id": props.client._id
        }
        AbonnementService.postAbonnement(props.folderId, { abonnements: [newAbonnement] }).then(res => {
            for (var brouillonId in res.data.data.brouillons) {
                navigate(`/${props.folderId}/abonnements/brouillon?brouillonId=${brouillonId}&from=abonnements`)
            }
        }).catch(error => {
            setGlobalError(error)
        });
    }
      
    return (
        <>
            {globalError && <ErrorManager error={globalError} />}

            {!globalError &&
                <span className='mb-3 d-block'>
                    {granted(grants, "abonnements.edit") &&
                        <Button variant="primary" className="d-flex ms-auto" onClick={() => createNewAbonnement()}>Créer un abonnement</Button>
                    }
                </span>
            }

            {getAbonnementsLoading && <span className="hloader"></span>}

            {(!getAbonnementsLoading && (abonnementsData?.count == 0 || !abonnementsData?.count) && !globalError) && <em>- Aucun élément trouvé -</em>}

            {(!getAbonnementsLoading && !globalError && abonnementsData?.abonnements.length > 0) &&
                <>
                    <Accordion>
                        {abonnementsData?.abonnements.map(abonnement => (
                            <Accordion.Item key={abonnement._id} eventKey={abonnement._id} className="border-0 mb-2">
                                <Accordion.Header>
                                    <span className="d-flex w-100">{abonnement.code} le {new Date(abonnement.date).toLocaleDateString()} <span className="ms-auto me-4 text-gray-600">{currencyFormat(abonnement.total_ttc)} {parametres?.general?.devise_dossier} TTC</span></span>
                                </Accordion.Header>
                                <Accordion.Body className="px-1">
                                    <Row>
                                        <Col>
                                            {/* <Split border title="Type" value={abonnement.type} />
                                            <Split border title="Code" value={abonnement.code} /> */}
                                            <Split border title="Date" value={new Date(abonnement.date).toLocaleString()} />
                                            <Split border title="Observation" value={abonnement.observation} />
                                            <Split border title="Adresse de facturation" value={abonnement.adresse_facturation?.adresse} />
                                            <Split border title={`Total TTC (${parametres?.general?.devise_dossier})`} value={currencyFormat(abonnement.total_ttc)} />
                                            <Split title="" value={<a href={`/${props.folderId}/abonnements?abonnementId=${abonnement._id}`} target="_blank">Afficher l'abonnement</a>} />
                                        </Col>
                                    </Row>
                                </Accordion.Body>
                            </Accordion.Item>
                        ))}
                    </Accordion>
                    <Pagination className="mt-3" itemsLength={abonnementsData?.total} elementsPerPage={abonnementsParams.current.limit} currentPagination={currentPagination} changePagination={p => onChangePagination(p)} />
                </>
            }
        </>
    );
}
export default Abonnements;